<div class="wrapper">
  <section class="contact">
    <div class="contact-title">
      <h2>{{ "drop us a line" | translate }}</h2>
      <span>{{ "We are a travel agency" | translate }}</span>
      <p [innerHTML]="'we\'re excited to hear from you' | translate"></p>
    </div>

    <app-form/>

    <div class="contact-findUS">
      <div class="contact-findUS-title">
        <span>{{ "also find us" | translate }}</span>
      </div>

      <div class="contact-findUS-appText">
        <div class="contact-findUS-appText-item">
          <div class="logo">
            <img src="../../../../assets/img/phones/zangi.png" alt="Zangi">
          </div>

          <div class="phone">
            <span>+374 93 31 31 52</span>
          </div>

          <div class="app">
            <span>Zangi</span>
          </div>
        </div>

        <div class="contact-findUS-appText-item">
          <div class="logo otherSize">
            <img src="../../../../assets/img/phones/whatsApp.png" alt="WhatsApp">
          </div>

          <div class="phone">
            <span>+374 93 31 31 52</span>
          </div>

          <div class="app">
            <span>WhatsApp</span>
          </div>
        </div>

        <div class="contact-findUS-appText-item">
          <div class="logo otherSize">
            <img src="../../../../assets/img/phones/viber.png" alt="Viber">
          </div>

          <div class="phone">
            <span>+374 93 31 31 52</span>
          </div>

          <div class="app">
            <span>Viber</span>
          </div>
        </div>
      </div>

      <div class="contact-findUS-email">
        <span>{{ "E-mail" | translate }}: info.tourdearmenia&#64;gmail.com</span>
      </div>
    </div>
  </section>
</div>
